import { Segment } from './../enums';
export const isCommonSegment = (segment) => {
    return [Segment.minutes, Segment.seconds, Segment.hours, Segment.year].includes(segment);
};
